import { motion } from "framer-motion";
import { KeyRound, MessageSquarePlus, ArrowUpRight } from "lucide-react";

const services = [
  {
    icon: KeyRound,
    tag: "SERVICE 01",
    title: "Ready Steam Accounts",
    description:
      "Δεν έχεις δικό σου account; Κανένα πρόβλημα. Διαθέτουμε έτοιμα accounts για τα περισσότερα παιχνίδια της λίστας μας στο Steam. PUBG, Dead by Daylight, Phasmophobia, The Planet Crafter, StarRupture, Species Unknown, MECCHA CHAMELEON και άλλα.",
    cta: "Ρωτησε μας",
    href: "tel:2221020988",
    testid: "service-accounts",
  },
  {
    icon: MessageSquarePlus,
    tag: "SERVICE 02",
    title: "Request a Game",
    description:
      "Θέλεις να προτείνεις κάποιο παιχνίδι ή έχεις κάποιο αίτημα; Στείλε μας μήνυμα στο Instagram ή πάρε μας τηλέφωνο. Το προσθέτουμε ασυζητητί αν είναι εφικτό.",
    cta: "Στειλε DM",
    href: "https://www.instagram.com/ted.cafe.chk/",
    testid: "service-request",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-black border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-10 bg-sky-400" />
            <span className="font-mono text-[11px] tracking-[0.3em] text-sky-400 uppercase">
              What we offer
            </span>
          </div>
          <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.95] max-w-3xl">
            Ετοιμοι για καθε <span className="text-sky-400">request</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {services.map((s, i) => (
            <motion.a
              key={s.title}
              href={s.href}
              target={s.href.startsWith("http") ? "_blank" : undefined}
              rel="noreferrer noopener"
              data-testid={s.testid}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="group relative border border-zinc-800 bg-zinc-950/60 p-8 md:p-10 hover:border-sky-400 transition-all overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-sky-400/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity" />

              <div className="relative z-10 flex flex-col h-full">
                <div className="flex items-center justify-between mb-8">
                  <span className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 uppercase">
                    {s.tag}
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-zinc-600 group-hover:text-sky-400 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                </div>

                <s.icon className="w-10 h-10 text-sky-400 mb-6" />

                <h3 className="font-display text-white text-2xl md:text-3xl uppercase leading-tight mb-4">
                  {s.title}
                </h3>
                <p className="text-zinc-400 text-sm md:text-base leading-relaxed flex-1">
                  {s.description}
                </p>

                <div className="mt-8 pt-6 border-t border-zinc-800">
                  <span className="inline-flex items-center gap-2 text-sky-400 font-bold text-sm uppercase tracking-widest">
                    {s.cta}
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
